import { Button, Col, Form, Input, Row, Select } from 'antd';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { addTicket } from '../../actions/business';

const { TextArea } = Input;
const layout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 16 },
};

const AddTicket = ({ handleSubmit, userData, handleCancel }: any) => {
    const navigate = useNavigate();
    const businessDetails = useSelector((state:any)=> state?.Auth?.user?.data);
     // Initial values for the form
  const initialValues = {
    companyName: businessDetails?.companyName,
    profilePhoto: businessDetails?.profilePhoto,
    contactName: businessDetails?.contactName,
    firstName: businessDetails?.firstName,
    lastName: businessDetails?.lastName,
    position: businessDetails?.position,
    email: businessDetails?.email,
    mobileNumber: businessDetails?.mobileNumber,
    contactNumber: businessDetails?.contactNumber,
    address: businessDetails?.address,
    businessCategory: businessDetails?.businessCategory,
    businessCode: businessDetails?.businessCode,
    role: businessDetails?.role,
    // description: businessDetails?.businessDetails.description,
    services: businessDetails?.businessDetails?.services,
    banner: businessDetails?.businessDetails?.banner,
    contactPerson: businessDetails?.businessDetails?.contactPerson,
    businessAddress: businessDetails?.businessDetails?.address,
    city: businessDetails?.businessDetails?.city,
    state: businessDetails?.businessDetails?.state,
    country: businessDetails?.businessDetails?.country,
    pinCode: businessDetails?.businessDetails?.pinCode,
  };

    const [abn, setAbn] = useState("")
    const [form] = Form.useForm();
    const dispatch = useDispatch();

    const onFinish = (values: any) => {
        const payload = {
            companyName: values?.companyName,
            abn: values?.abn,
            position: values?.position,
            contactName: values?.contactName,
            email: values?.email,
            mobileNumber: values?.mobileNumber,
            contactNumber: values?.contactNumber,
            address: values?.address,
            description: values?.description,
        };
        dispatch(
            addTicket(payload, (resp: any) => {
                if(resp?.status === 200) {
                    handleCancel()
                }
            })
        );

    };
    const onFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
        // You can also display an error message to the user here
    };

    const validateAbn = (abn: string) => {
        const abnRegex = /^(\d{11})$/;
        if (!abnRegex.test(abn.replace(/\s+/g, ''))) {
            return {
                validateStatus: 'error' as const,
                errorMsg: 'Invalid ABN',
            };
        }
        return {
            validateStatus: 'success' as const,
            errorMsg: "",
        };
    };

    const handleAbnChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setAbn(e.target.value);
    };

    const validateMobileInput = (event: React.KeyboardEvent<HTMLInputElement>) => {
        const allowedKeys = ['Backspace', 'Tab', 'Enter', 'ArrowLeft', 'ArrowRight', 'Delete'];
        const regex = /^[0-9()+\s]$/; // Allow digits, (), +, and spaces

        if (!regex.test(event.key) && !allowedKeys.includes(event.key)) {
            event.preventDefault();
        }
    };

    return (
        <div>
            <div className='' style={{ paddingTop: '30px'}}>
                <Row>
                    <Col lg={24} md={24} sm={24}>
                        <Form className='formControl'
                            layout="vertical"
                            form={form}
                            {...layout}
                            onFinish={onFinish}
                            initialValues={initialValues}
                            onFinishFailed={onFailed}
                        >
                            {/* <Form.Item
                                name="companyName"
                                className='formControlDesign'
                                label="Company Name"
                                tooltip="A mandatory field as the company name is important throughout the entire system. If you are part of a business chain or franchise enter the name and then enter your branch . i.e.: Super Cheap Auto - Blacktown"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your comapny name!',
                                    }
                                ]}
                            >
                                <Input placeholder='Company Name' />
                            </Form.Item> */}
                            {/* <Form.Item
                                name="abn"
                                label="ABN"
                                className='formControlDesign'
                                tooltip="A non-mandatory field. This is a business identification in Australia"
                            >
                                <Input placeholder='ABN' value={abn} onChange={handleAbnChange} />
                            </Form.Item> */}
                            <Form.Item
                                name="contactName"
                                label="Contact Name"
                                className='formControlDesign'
                                tooltip="The main person using ReferUs"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input contact name!',
                                    }
                                ]}
                            >
                                <Input placeholder='Contact Name' />
                            </Form.Item>
                            <Form.Item
                                name="position"
                                label="Position"
                                className='formControlDesign'
                                tooltip="Non-mandatory but may come in handy in a future update to complete this field"
                            >
                                <Input placeholder='Position' />
                            </Form.Item>
                            <Form.Item
                                name="email"
                                label="Email Address"
                                className='formControlDesign'
                                tooltip="Mandatory field as this is how we communicate with you."
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input your email!',
                                    },
                                    {
                                        type: 'email',
                                        message: 'The input is not valid E-mail!',
                                    },
                                ]}
                            >
                                <Input placeholder='Email Address' />
                            </Form.Item>
                            {/* <Form.Item
                                className="formControlDesign"
                                label="Mobile Number"
                                name="mobileNumber"
                                tooltip="Mandatory field so the system can contact you."
                                rules={[
                                    { required: true, message: 'Please input your Mobile Number!' },
                                    {
                                        validator: (_, value) => {
                                            const countryCode = '+61'; // Australia country code
                                            const phoneNumber = value.replace(countryCode, '');
                                            if (phoneNumber && phoneNumber.length === 10) {
                                                return Promise.resolve();
                                            } else {
                                                return Promise.reject(new Error('Mobile Number must be exactly 10 digits!'));
                                            }
                                        },
                                    },
                                ]}
                            >
                                <Input
                                    addonBefore={'+61 '} // Display Australia country code by default
                                    placeholder="Mobile Number"
                                />
                            </Form.Item> */}
                            <Form.Item
                                name="contactNumber"
                                label="Contact Number"
                                className='formControlDesign'
                                tooltip="A mandatory field so admin can contact."
                                rules={[
                                    {
                                        required: true,
                                        message: 'Please input contact number!',
                                    }
                                ]}
                            >
                                <Input placeholder='Company Contact Number'
                                    maxLength={14}
                                    onKeyDown={validateMobileInput}
                                />
                            </Form.Item>

                            <Form.Item name="address" label="Address" className='formControlDesign'
                                tooltip="A non mandatory field.">
                                <Input placeholder='Enter Address' />
                            </Form.Item>

                            <Form.Item name="description" label="Description" className='formControlDesign'
                                tooltip="Describe your problem here which will help admin to take appropriate actions.">
                                <TextArea
                                    placeholder="Enter your description here"
                                    rows={4}
                                />
                            </Form.Item>

                            <div className="col-lg-12 mt-15">
                                <div className="text-end btn-groups-Forms">
                                    <button
                                        className="btn btn-outline-primary"
                                        onClick={() => { handleCancel() }}
                                        type='button'
                                    >
                                        Cancel
                                    </button>

                                    <Button className='btn btn-primary' type="primary" onClick={() => form.submit()}>
                                        Submit
                                    </Button>
                                </div>
                            </div>


                        </Form>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default AddTicket